import {
  AppstoreOutlined, BarChartOutlined, CalculatorOutlined, TeamOutlined
} from '@ant-design/icons';
import {
  ADMIN_ACCOUNTING, ADMIN_ANALYTICS, ADMIN_PRODUCTS, ADMIN_USERS
} from 'constants/routes';
import { useDocumentTitle, useScrollTop } from 'hooks';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  useDocumentTitle('Welcome | Admin Dashboard');
  useScrollTop();
  const profile = useSelector((state) => state.profile);

  const sections = [
    {
      path: ADMIN_PRODUCTS,
      title: 'Products',
      description: 'Add, edit, search, and manage products.',
      icon: AppstoreOutlined,
      tone: 'blue'
    },
    {
      path: ADMIN_USERS,
      title: 'Registered Users',
      description: 'Activate profiles and manage plans and roles.',
      icon: TeamOutlined,
      tone: 'violet'
    },
    {
      path: ADMIN_ANALYTICS,
      title: 'Profile Analytics',
      description: 'Track total profile views, top users, traffic sources, and devices.',
      icon: BarChartOutlined,
      tone: 'orange'
    },
    {
      path: ADMIN_ACCOUNTING,
      title: 'الحسابات والمخزون',
      description: 'إدارة الطلبات والخامات والعروض والتقارير الشهرية.',
      icon: CalculatorOutlined,
      tone: 'green'
    }
  ];

  return (
    <div className="admin-dashboard-home">
      <section className="admin-dashboard-hero">
        <div>
          <span className="admin-dashboard-kicker">ADMIN DASHBOARD</span>
          <h1>
            Welcome back,
            {' '}
            {profile?.fullname || 'Admin'}
          </h1>
          <p>Choose a workspace below to manage your business.</p>
        </div>
        <div className="admin-dashboard-hero-badge">TaKKa</div>
      </section>

      <section className="admin-dashboard-links">
        {sections.map((section) => {
          const Icon = section.icon;
          return (
            <Link
              className={`admin-dashboard-card admin-dashboard-card-${section.tone}`}
              key={section.path}
              to={section.path}
            >
              <span className="admin-dashboard-card-icon"><Icon /></span>
              <div>
                <h3>{section.title}</h3>
                <p>{section.description}</p>
              </div>
              <span className="admin-dashboard-arrow">→</span>
            </Link>
          );
        })}
      </section>
    </div>
  );
};

export default Dashboard;
